import { render, staticRenderFns } from "./AddWebsiteModal.vue?vue&type=template&id=f6970be0&"
import script from "./AddWebsiteModal.vue?vue&type=script&lang=ts&"
export * from "./AddWebsiteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports